import { Component, OnInit } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';

@Component({
  selector: 'app-signup-options-step-one',
  templateUrl: './signup-options-step-one.component.html',
  styleUrls: ['./signup-options-step-one.component.scss'],
})

export class SignupOptionsStepOneComponent implements OnInit {

  constructor(
    private readonly navigator: Navigator,
  ) {
  }

  ngOnInit() {
  }

  public navigateTo(page: string, data): any {
    return this.navigator.navigateTo(page, data);
  }

}
